import "core-js/modules/web.dom.iterable";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import { previewDataInterface } from '@/api/systemData/dataInterface'
import request from "@/utils/request";
export default {
  name: "showhidebutt",
  props: {
    cityOptions: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    icon: {
      type: String,
      default: ""
    },
    type: {
      type: String,
      default: ""
    },
    transvalue: {
      type: String,
      default: ""
    },
    appendtobody: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      visible: false,
      checkAll: false,
      checkedCities: [],
      cities: this.cityOptions,
      isIndeterminate: true,
      loadingbut: false
    };
  },
  watch: {},
  computed: {},
  created: function created() {},
  methods: {
    select: function select() {
      var _this = this;
      if (this.checkedCities.length != 0) {
        if (this.pageConfig.length != 0) {
          this.pageConfig.forEach(function (element) {
            element.Index = false;
            _this.checkedCities.forEach(function (elements) {
              if (element.Columns == elements) {
                element.Index = true;
              }
            });
          });
        } else {
          this.cities.forEach(function (element) {
            _this.pageConfig.push({
              Columns: element,
              Width: "",
              Index: false
            });
            _this.checkedCities.forEach(function (elements, index) {
              if (element == elements) {
                _this.pageConfig[index].Index = true;
              }
            });
          });
        }
        request({
          url: "/api/WMS/TableAdjustmentConfig/SetTableAdjustmentConfig",
          method: "post",
          data: {
            pageType: this.transvalue,
            pageConfig: this.pageConfig
          }
        }).then(function (res) {
          _this.visible = false;
          _this.$message({
            message: res.msg,
            type: "success",
            duration: 1000
          });
          window.location.reload();
        });
      } else {
        this.$message({
          message: "最少勾选一个",
          type: "warning",
          duration: 1000
        });
      }
    },
    handleCheckAllChange: function handleCheckAllChange(val) {
      this.checkedCities = val ? this.cityOptions : [];
      this.isIndeterminate = false;
    },
    handleCheckedCitiesChange: function handleCheckedCitiesChange(value) {
      var checkedCount = value.length;
      this.checkAll = checkedCount === this.cities.length;
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.cities.length;
    },
    openDialog: function openDialog() {
      var _this2 = this;
      this.visible = true;
      request({
        url: "/api/WMS/TableAdjustmentConfig/SelectTableAdjustmentConfig?pageType=".concat(this.transvalue),
        method: "get"
      }).then(function (res) {
        _this2.pageConfig = res.data;
        _this2.checkedCities = [];
        _this2.pageConfig.forEach(function (element) {
          if (element.Index == "true") {
            _this2.checkedCities.push(element.Columns);
          }
        });
      });
    }
  }
};